import React, {useState, useEffect} from 'react'
import { Alert, Button, Col, Row, ListGroup, ListGroupItem } from 'reactstrap'
import { purchaseMachine } from 'containers/purchase/purchase_machine'
import PriceSummary from 'components/price_summary'
import { useMachine } from '@xstate/react'
import productMachineConfig from 'containers/purchase/machines/product_machine_config'
import {stepConfig, isLastStep, currentStep, stepStatus} from 'utils/step_utils'
import PurchaseWizard from 'containers/purchase/purchase_wizard'
import ProductHeader from 'containers/purchase/partials/product_header'
import PurchaseWrapper from 'ui/purchase_wrapper'
import useLayout from 'utils/hooks/use_layout'
import { useTranslation } from 'react-i18next'
import stopSales from 'img/stop-sales'
import {isMobile, isMobileOnly} from 'react-device-detect'
import cn from 'classnames'
import Page from 'ui/page'
import Modal from 'ui/modal'
import parse from 'react-html-parser'
import SummaryModal from 'containers/purchase/partials/summary_modal'

const NotificationModal = (props) => {
  const {notification, notification_type, modal, toggle} = props

  if (notification && notification_type == 'popup') {
    return (
      <Modal
        isOpen={modal}
        toggle={toggle}
      >
        {parse(notification)}
      </Modal>
    )
  } else {
    return null
  }
}

const ProductPurchase = (props) => {
  const {product_id, endpoints, product, cross_sell_products, cart_params, resSize = "wide"} = props
  const [notificationModal, setNotificationModal] = useState(true)
  const [cartModal, setCartModal] = useState(false)
  const toggleNotificationModal = () => setNotificationModal(!notificationModal)

  const {i18n} = useTranslation()
  const config = productMachineConfig(props.machine, props)
  const stepsConfig = config.steps

  const machine = useMachine(purchaseMachine(config), {
    context: {
      endpoints: endpoints,
      product_id: product_id,
      timezone: product.local_timezone,
      currency: product.currency,
      cross_sell_products: cross_sell_products
    }
  })

  const mode = useLayout()

  const [current, send] = machine
  const {reservation_ready, cart, redirect_url} = current.context

  useEffect(() => {
    if (current.value == 'reserved') {
      if (cart_params.enable_cart) {
        setCartModal(true)
      } else {
        document.location.href = redirect_url
      }
    }
  }, [current.value])

  const currentStepConfig = stepConfig(stepsConfig, current.value)

  const {error} = current.context
  const {product_status, title, notification, notification_type} = props.product

  const PurchaseError = ({error}) => (
    <div id="purchase-error">
      {error &&
        <Alert color="danger">{error}</Alert>
      }
    </div>
  )

  const ReservationButton = () => {
    return (
      <Button
        disabled={!reservation_ready}
        color={'danger'}
        className={cn('fw-semibold', 'text-white', 'w-100', 'btn-lg', 'rounded-5')}
        onClick={() => send('RESERVATION_REQUEST')}
      >
        {i18n.t('product_purchase.reservation_button')}
      </Button>
    )
  }

  if (product_status != 'active') {
    return (
      <PurchaseWrapper mode={mode} className="text-center p-3 container">
        <div className="alert alert-warning" role="alert">
          <h2>{title}</h2>
          <p className="m-0">{i18n.t('product_purchase.stop_sales_description')}</p>
          <img src={stopSales}/>
        </div>
      </PurchaseWrapper>
    )
  }

  const showReservationButton = !config.hideReservatioButton && isLastStep(stepsConfig, current.value)

  return (
    <Page {...props} className=" ">
      <NotificationModal
        notification={notification}
        notification_type={notification_type}
        modal={notificationModal}
        toggle={toggleNotificationModal}
      />

      <SummaryModal
        modal={cartModal}
        endpoints={endpoints}
        relatedProducts= {product.cross_sell_products}
        cart={cart}
        redirectUrl={redirect_url}
      />

      {props.mode == 'web' &&
        <ProductHeader {...props}/>
      }

      <div className="container mt-3">
        {props.mode == 'iframe' &&
          <h1 className="h3 text-center mb-3">{title}</h1>
        }
        {!isMobileOnly &&
          <PurchaseWizard stepActive={0}/>
        }
        <PurchaseError error={error}/>

        {Object.keys(stepsConfig).map((step) => {
          const Module = stepsConfig[step].component
          const moduleStatus = stepStatus(stepsConfig, step, currentStep(current.value))

          return (
            <Module
              key={step}
              config={props}
              machine={machine}
              status={moduleStatus}
              isLastStep={isLastStep(stepsConfig, current.value)}
              stepConfig={currentStepConfig}
              resSize={resSize}
              {...stepsConfig[step].componentProps}
            />
          )
        })}

        <Row>
          <Col xs="12" md="4" className={cn(['offset-0', showReservationButton ? "offset-md-6" : "offset-md-8"])}>
            <PriceSummary machine={machine}/>
          </Col>
          {showReservationButton &&
            <Col xs="12" md="2" className="mt-3 mt-md-0">
              <ReservationButton/>
            </Col>
          }
        </Row>
      </div>
    </Page>
  )
}

export default ProductPurchase
